import React from 'react';
import PropTypes from 'prop-types';
import CampaignRow from '../CampaignRow';
import { noop } from '../propTypes';
import campaignPropType from '../CampaignRow/propTypes';

function CampaignsList({ campaigns, onActiveToggle }) {
    const list =
        campaigns &&
        campaigns.map(
            (
                {
                    id,
                    name,
                    description,
                    thumbnail,
                    badge,
                    progress,
                    pickups,
                    target,
                    startDate,
                    endDate,
                    isActive,
                },
                index,
            ) => {
                return (
                    <CampaignRow
                        key={id}
                        id={id}
                        name={name}
                        description={description}
                        badge={badge}
                        thumbnail={thumbnail}
                        progress={progress}
                        pickups={pickups}
                        target={target}
                        startDate={startDate}
                        endDate={endDate}
                        toggleState={isActive}
                        onToggle={() => {
                            onActiveToggle(index);
                        }}
                    />
                );
            },
        );

    return <div>{list}</div>;
}

CampaignsList.propTypes = {
    // campaigns array to be displayed inside list
    campaigns: PropTypes.arrayOf(
        PropTypes.shape({
            ...campaignPropType,
            isGlobal: PropTypes.bool,
            isConnected: PropTypes.bool,
            isActive: PropTypes.bool,
        }),
    ),
    // function called when the switch button is toggled
    onActiveToggle: PropTypes.func,
};

CampaignsList.defaultProps = {
    campaigns: [],
    onActiveToggle: noop,
};

export default CampaignsList;
